import { useState } from "react";
import { HeadingText, Tabs } from "../../../shared/ui";
import { useKybStats } from "../../../shared/api/hooks/useKybStats";
import KybComplianceStatsSection from "../components/KybComplianceStatsSection";
import KybComplianceTableSection from "../components/KybComplianceTableSection";

const BUSINESS_SOURCE_TABS = [
  { label: "All", value: "all" },
  { label: "Customers", value: "tradevu" },
  { label: "Partners", value: "partner" },
];

const KybCompliancePage = () => {
  const [businessSource, setBusinessSource] = useState("all");
  const { stats, error, refetch } = useKybStats({
    sort: "all",
    businessType: businessSource === "all" ? undefined : businessSource,
  });

  return (
    <section className="min-h-full bg-[#F3F4F8] md:p-6">
      <div className="rounded-[16px] bg-white p-4 md:p-6">
        <HeadingText className="aku-heading-h1-medium text-[#161827]">
          KYB &amp; Compliance
        </HeadingText>

        <Tabs
          items={BUSINESS_SOURCE_TABS}
          value={businessSource}
          onChange={setBusinessSource}
          className="my-4"
        />

        <KybComplianceStatsSection
          stats={stats}
          error={error}
          onRetry={refetch}
        />
        <KybComplianceTableSection
          statusCounts={stats?.statusCounts}
          businessSource={businessSource}
        />
      </div>
    </section>
  );
};

export default KybCompliancePage;
